import React, { useState, useEffect ,useContext} from 'react';
import axios from 'axios';
import './portfolio.css';
import {   useNavigate , useLocation, NavLink} from 'react-router-dom';
import Sidebar from '../Home/Sidebar';
import Loader from '../Loader/Loader';
import { Button } from "react-bootstrap";
import { AuthContext } from "../../contexts/AuthProvider";
import Addportfolio from './Addportfolio';


const Portfolio = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isLoading, setIsLoading] = useState(true);

  const { user } = useContext(AuthContext);
  // console.log(location);
   const [portfolios, setPortfolios] = useState([]);
    async function callAPI(id) {
       navigate(`/portfolio/update/${id}`)
    }
    useEffect(() => {
      const fetchData = async () => {
        const result = await axios.get('https://apichatgptresponse.managedcoder.com/api/techstack/getAllTechstacks/'+user.email);
        setPortfolios(result.data);
      //  console.log(result);
      setIsLoading(false);
      };
  
      fetchData();
      // return => {}
    }, [location]);
    return (
    <>
      { isLoading ? (<Loader />) : 
      ( <div className="row">
          <div className="col-3">
            <Sidebar />
          </div>
         
          <div className="col-9">
            <div className="page-title ">    
              <div className='container my-5 '>
                <div className='float-right'>
                  {/* <a href='/addportfolio'> */}
                  <NavLink
                to="/addportfolio"
                className={({ isActive }) =>
                  `nav-link text-white ${isActive ? "active" : undefined}`
                }
              >
                    <Button
                      className="mt-4 submit-btn"
                      variant="primary"
                      type="submit">
                        Add Portfolio
                    </Button>
                  {/* </a> */}
                  </NavLink>
                </div>
                <table  className="table ">
                  <thead>
                    <tr>
                        <th>Tech Stack</th>
                        <th>Portfolio</th>
                        <th>Projects</th>
                        <th>Action</th>             
                    </tr>
                  </thead>
                  <tbody>
                    {portfolios.map((portfolio) => (
                      <tr key={portfolio._id}>        
                        <td data-label="Tech Stack">{portfolio.tech_stack}</td>
                        <td data-label="Portfolio">{portfolio.portfolio && portfolio.portfolio.length > 60 ? portfolio.portfolio.substring(0,60) + '...': portfolio.portfolio}</td>
                        <td data-label="Projects">{portfolio.projects && portfolio.projects.length > 60 ?  portfolio.projects.substring(0,60) + '...': portfolio.projects}</td>
                        <td  data-label="Action"><button className="btn edit-btn" onClick={()=>callAPI(portfolio._id)}>Edit</button></td>        
                      </tr>
                        ))}        
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>) }  
    </>
    );
  };
  
  export default Portfolio;

  
